import { useQuery } from "@tanstack/react-query";
import bankApi from "../../api/bankApi";

export const useGetAllBank = () => {
    return useQuery({
        queryKey: ["banks"],
        queryFn: () => bankApi.getAllBank(),
    });
};
